import { getDefaultLanguage } from './browser';
import { USER_LANGUAGES } from '../assets/AppConstants';
import { COUNTRY_FLAGS_URL } from '../assets/constants/Misc';

const getLang = () => {
  let language = getDefaultLanguage().id;
  const userString = localStorage.getItem('user');
  if (userString && userString !== 'null') {
    const useUser = JSON.parse(userString);
    if (useUser?.language) language = useUser.language;
  }

  return USER_LANGUAGES.find((el) => (
    el.id.toLocaleLowerCase() === language.toLocaleLowerCase()
  ))?.amount;
};

export const convertAmount = (currency, value, style = 'decimal', decimals = 2) => {
  const formatter = Intl.NumberFormat(getLang(), {
    style,
    currency: currency || 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  if (value === null || value === undefined || value === '') return '-';
  if (Number.isNaN(value)) return '-';
  return formatter.format(value);
};

export const withDecimals = (value, style = 'decimal', decimals = 2) => {
  const formatter = Intl.NumberFormat(getLang(), {
    style,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  if (value === null || value === undefined || value === '') return '-';
  if (Number.isNaN(value)) return '-';
  return formatter.format(value);
};

export const convertShortAmount = (currency, value) => {
  const formatter = Intl.NumberFormat(getLang(), {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    notation: 'compact',
    compactDisplay: 'short',
    currency: currency || 'USD',
  });

  if (value === null || value === undefined || value === '') return '-';
  if (Number.isNaN(value)) return '-';
  return formatter.format(value);
};

export const convertNiceShortAmount = (currency, value) => {
  const formatter = Intl.NumberFormat(getLang(), {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    notation: 'compact',
    compactDisplay: 'short',
    currency: currency || 'BRL',
  });

  if (value === null || value === undefined || value === '') return '-';
  if (Number.isNaN(value)) return '-';
  return formatter.format(value);
};

export const convertCurrency = (currency, currencyDisplay = 'narrowSymbol') => {
  const formatter = Intl.NumberFormat(getLang(), {
    style: 'currency',
    currency: currency || 'USD',
    currencyDisplay,
  });

  const newValue = formatter.formatToParts(0);
  const findCurrency = newValue.find((el) => el.type === 'currency');

  if (currencyDisplay === 'name') return findCurrency?.value;
  return currency !== 'BRL' ? currency : findCurrency?.value;
};

export const getCurrencyFlag = (currency) => `${COUNTRY_FLAGS_URL}${currency.slice(0, 2).toLocaleLowerCase()}.svg`;

export const resolveCurrencies = (currencies) => currencies.map(({
  id,
  description,
}) => ({
  id,
  description,
  name: id,
  flag: getCurrencyFlag(id),
}));

export const numberFormat = (currency, value) => {
  const formatter = Intl.NumberFormat('en', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    notation: 'compact',
    compactDisplay: 'short',
    currency: currency || 'USD',
  });
  if (value === null || value === undefined || value === '') return '-';
  if (Number.isNaN(value)) return '-';
  return formatter.format(value);
};

export const getCurrencyInfo = (currency = 'USD', options = {}) => {
  const formatter = Intl.NumberFormat(getLang(), {
    style: 'currency',
    currency,
    ...options,
  });

  const numberParts = formatter.formatToParts(1234567.89);

  const symbol = currency !== 'BRL' ? currency : numberParts.find((part) => part.type === 'currency')?.value;
  const thousandsSeparator = numberParts.find((part) => part.type === 'group')?.value;
  const decimalSeparator = numberParts.find((part) => part.type === 'decimal')?.value;

  return {
    symbol,
    thousandsSeparator,
    decimalSeparator,
  };
};
